import { render, staticRenderFns } from "./PopupAccountDeletion.vue?vue&type=template&id=3fb7b59e&scoped=true"
import script from "./PopupAccountDeletion.vue?vue&type=script&lang=js"
export * from "./PopupAccountDeletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7b59e",
  null
  
)

export default component.exports